import React, { Component } from "react";
import Media from "react-media";

import { getStringOrDefault } from "./scripts/resources";

class Header extends Component {
  render() {
    return (
      <div>
        <Media query="(min-device-width: 1224px)">
          <div className="header wide">
            <img
              src="assets/crown.svg"
              alt="Visit CheckPoint.com"
              className="crown wide"
            />
            <h1 style={{ marginLeft: 80 }}>{getStringOrDefault("appTitle")}</h1>
            <a
              href="https://www.checkpoint.com/"
              title="Visit CheckPoint.com"
              aria-label="Check Point Homepage"
            >
              <img
                src="assets/CP_Logo.svg"
                alt="Visit CheckPoint.com"
                className="cplogo wide"
              />
            </a>
          </div>
        </Media>
        <Media query="(max-device-width: 1224px)">
          <div className="header mobile">
            <h1 className="mobile">{getStringOrDefault("appTitle")}</h1>
            <a
              href="https://www.checkpoint.com/"
              title="Visit CheckPoint.com"
              aria-label="Check Point Homepage"
            >
              <img
                src="assets/CP_Icon.svg"
                alt="Visit CheckPoint.com"
                className="cplogo mobile"
              />
            </a>
          </div>
        </Media>
      </div>
    );
  }
}

export default Header;
